import { Component } from '@angular/core';
import { CaptchaService } from './shared/captcha.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FeevClientApp';

  constructor(captcha: CaptchaService) {
    captcha.precarregar();
  }
}
